import React from 'react';
import Helmet from 'react-helmet';

import { LinkData } from 'ha/modules/Hermes/types';
import { withIntl, IntlProps } from 'ha/i18n';

interface Props {
  metaTitle: string;
  socialNetworkTitle?: string;
  metaDescription: string;
  linkData?: LinkData[];
  titleTemplateOn?: boolean;
}

export const HermesMeta: React.FC<Props & IntlProps> = ({
  metaTitle,
  socialNetworkTitle,
  metaDescription,
  linkData,
  titleTemplateOn = true,
  intl: { urlResolver },
}) => {
  return (
    <Helmet
      titleTemplate={titleTemplateOn ? '%s | HousingAnywhere' : undefined}
    >
      <title>{metaTitle}</title>
      <meta property="og:title" content={socialNetworkTitle || metaTitle} />
      <meta name="description" content={metaDescription} />
      <meta property="og:description" content={metaDescription} />
      {linkData ? (
        linkData.map(linkProps => (
          <link
            {...linkProps}
            href={urlResolver.absolutizePath(linkProps.href, {
              skipAddLanguage: true,
            })}
            key={`${linkProps.rel}-${linkProps.href}`}
          />
        ))
      ) : (
        <meta name="robots" content="noindex" />
      )}
    </Helmet>
  );
};

export default withIntl(HermesMeta);
